import React from 'react';

const SearchPopup = () => {

  return (
    <>
        {/* Search Popup */}
        <div id="search-popup" className="search-popup">
            <div className="popup-inner">
                <div className="upper-box clearfix">
                    <figure className="logo-box pull-left"><a href="/"><img src="assets/images/logo_new.jpeg" alt="" className="search-popup-logo" style={{width: '66.67%', height: 'auto'}} /></a></figure>
                    <div className="close-search pull-right"><span className="far fa-times"></span></div>
                </div>
                <div className="overlay-layer"></div>
                <div className="auto-container">
                    <div className="search-form">
                        <form method="post" action="/">
                            <div className="form-group">
                                <fieldset>
                                    <input type="search" className="form-control" name="search-input" value="" placeholder="Type your keyword and hit" required />
                                    <button type="submit"><i className="far fa-search"></i></button>
                                </fieldset>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
  }
  
  export default SearchPopup;